<template>
  <router-view name="dailyOrderReports" v-bind:key="$route.path"></router-view>
</template>
<script>
export default {
  name: "DailyOrderReports",
};
</script>
